// 希伯来----address
module.exports = {
  validate: {
    noEmail: "אימייל לא יכול להיות ריק, אנא הכנס מחדש",
    noPhone: "מספר הטלפון לא יכול להיות ריק, נא להזין מחדש",
    errorReg:
      "אורך הקלט הוא 1-50 ספרות, אתה יכול להזין אותיות רישיות וקטנות, מספרים, סמלים - . _ @",
    noPassword: "הסיסמה לא יכולה להיות ריקה, נא להזין מחדש",
    pwdReg: "אורך הזנת סיסמה הוא 8-32 ספרות בלבד ועליו להכיל מספרים ואותיות",
    pwdCheck: "שתי הסיסמאות שהוזנו אינן עקביות, נא להזין מחדש",
    pwdLengthReg: "אורך הסיסמה נע בין 8 ל-32, נא לאשר את הקלט",
    noCode: "אנא הזן קוד אימות",
    codeReg: "אנא הזן קוד אימות בן 6 ספרות",
    nullText: "הקלט לא יכול להיות ריק, אנא הכנס מחדש",
    phoneCheck: "מספר הטלפון שהוזן פעמיים אינו עקבי, אנא הכנס שוב",
    emailNumReg: "אורך קלט הדוא  ל הוא 6 - 50 תווים, נא להזין מחדש ",
    emailReg: "כתובת אימייל שגויה, נא להזין מחדש",
    emailCheck: "חשבון הדוא ל שהוזן פעמיים אינו עקבי, אנא הכנס מחדש ",
    noUsername: "הסיסמה לא יכולה להכיל את מספר החשבון, נא להזין מחדש",
    accountReg: "הזנת שם החשבון שגויה, נא להזין מחדש",
  },
  area: {
    areaTitle: "ניהול שטח",
    add: "הוסף אזור",
    area: "אֵזוֹר",
    addNextArea: "צור אזור כפוף חדש",
    areaNameTip: "אנא הזן שם אזור",
    areaNameHold: "אורך הקלט הוא 1-20 ספרות, לא ניתן להזין סמלים מיוחדים",
    areaNumHold:
      "אורך הקלט הוא 1-4 ספרות, ניתן להזין רק מספרים, וטווח המספרים הוא 0-9999",
    areaNumTip: "נא להזין את מספר האזור",
    areaName: "שם אזור",
    checkAreaName: "שם האזור לא יכול להיות ריק, נא להזין מחדש",
    areaNameTip1: "שם האזור לא יכול להיות ריק",
    areaNameTip2: "קלט שם אזור שגוי, נא להזין מחדש",
    areaNum: "מספר אזור",
    checkAreaNum: "מזהה אזור לא יכול להיות ריק, אנא הכנס מחדש",
    lastLevel: "שייך לאזור העליון",
    checkLastLevel:
      "האזור ברמה העליונה שאליו הוא שייך לא יכול להיות ריק, אנא בחר שוב",
    lastLevelTip: "אנא בחר את אזור האב שאליו אתה שייך",
    delInfo:
      "ביצוע משימת המחיקה הזו ימחק את הנתונים באזור זה ולא ניתן לשחזר אותם",
    oneStep: "רמה אחת",
    twoStep: "מִשׁנִי",
    threeStep: "רמה 3",
    fourStep: "רמה 4",
    fiveStep: "רמה 5",
    delAreaTip: "יש אזור כפוף, שלא ניתן למחוק",
    personArea: "האדם אינו כבול לאזור",
    areaType: "הוסף שיטה",
    addArea1: "הוסף בנפרד",
    addArea2: "תוספת מתמשכת",
    addArea3: "תוספת מטריקס",
    areaNameTop: "קידומת שם אזור",
    areaNameLast: "סיומת שם אזור",
    areaJoinHold: "אנא הזן את קידומת שם הדומיין",
    areaJoinHold1: "אנא הזן את סיומת שם האזור",
    startNum: "מספר התחלה",
    checkStartNum: "הקלטת המספר הראשונית שגויה, נא להזין מחדש",
    checkStartNum1: "הקלט של המספר ההתחלתי לא יכול להיות ריק, נא להזין מחדש",
    checkEndNum: "הזנת מספר סיום שגויה, נא להזין מחדש",
    checkEndNum1: "מספר סיום לא יכול להיות ריק, נא להזין מחדש",
    endNum: "מספר סיום",
    topStart: "מספר התחלה של כותרת",
    checkTopStart: "הקלטת המספר ההתחלתי הראשון שגויה, נא להזין מחדש",
    checkTopStart1:
      "הקלט של המספר ההתחלתי הראשון לא יכול להיות ריק, נא להזין מחדש",
    topEnd: "מספר קצה של כותרת",
    checkTopEnd: "הזן את המספר הסופי של הכותרת שגויה, נא להזין מחדש",
    checkTopEnd1: "הקלט של מספר הקצה הראשון לא יכול להיות ריק, נא להזין מחדש",
    lastStart: "מספר התחלה של זנב",
    checkLastStart: "הקלט של מספר תחילת הזנב שגוי, נא להזין מחדש",
    checkLastStart1: "הזן את מספר תחילת הזנב לא יכול להיות ריק, נא להזין מחדש",
    lastEnd: "מספר סוף מסלול",
    checkLastEnd: "הזן את המספר הסופי של הזנב שגוי, נא להזין מחדש",
    checkLastEnd1: "הקלט של מספר קצה הזנב לא יכול להיות ריק, נא להזין מחדש",
    topTip:
      "אורך הקלט הוא 1-2 ספרות, ניתן להזין רק מספרים, וטווח המספרים הוא 1-99",
    lastTip:
      "אורך הקלט הוא 1-2 ספרות, ניתן להזין רק מספרים, וטווח המספרים הוא 1-99",
    areaNameTest: "דוגמה לשם אזור",
  },
  addressBook: {
    config: "תצורת פרויקט",
    errorTip: "שגיאה בפורמט ספר הכתובות",
    upgrade: "ניהול שדרוג ספר כתובות",
    deviceIdTip: "אנא הזן את מזהה המכשיר",
    deviceId: "זיהוי מכשיר",
    syncAll: "סנכרן הכל",
    sync: "לְסַנכְרֵן",
    sysVersion: "גרסה נוכחית של פנקס כתובות המערכת",
    deviceVersion: "גרסה נוכחית של פנקס הכתובות של המכשיר",
    syncTip: "הוציא את הפקודה הסינכרונית בהצלחה",
  },
  newarea: {
    add: "הוסף אזור",
    edit: "אזור ערוך",
    smallTip: "כרגע רמת השטח הקטן ביותר, לא ניתן להוסיף אזורי משנה נוספים",
    batch: "אזור הוספת אצווה",
    batch1: "תוספת מתמשכת",
    batch2: "תוספת מטריקס",
  },
  deviceSip: {
    saveTip:
      "אנא ייצא את פנקס הכתובות בזמן, אחרת כל הנתונים יימחקו לאחר היציאה מהדף.",
    devMsg: "מידע על המכשיר",
    list: "רשימת התקנים",
    add: "הוסף מכשיר",
    edit: "ערוך מכשיר",
    batch: "הוסף מכשירים באצווה",
    areaChosen: "בחירת רמת אזור",
    areaNum: "מספר המכשירים החדשים שנוספו בכל אזור",
    bacthTip:
      "כאשר רמת השטח נבחרה כבניין, ומספר המכשירים החדשים בכל אזור הוא 4, זה אומר שמתווספים 4 מכשירים בכל אזור שנוצר",
    note: "להמחיש",
    baseConfig: "תצורת מידע בסיסי",
    deviceName: "שם התקן",
    nameTip: "תוקן להוסיף מספר לשם הקבוצה שאליה הוא שייך, למשל בניין 1-1",
    function: "פונקציית תמיכה במכשיר",
    net: "תצורת רשת",
    netType: "סוג רשת",
    netTip1: "סטטי היא רשת סטטית, אתה צריך להגדיר ידנית את ה-IP ומידע אחר.",
    netTip2: "DHCP היא רשת דינמית, ומידע כגון IP מוקצה אוטומטית על ידי הנתב.",
    mask: "אנא הזן את מסיכת רשת המשנה",
    gateway: "נא להיכנס לשער",
    ip: "אנא הזן את כתובת ה-IP",
    ipTip: "כתובת ה-IP הקלט צריכה להימנע מ-IP מיוחד, כגון 127.0.0.1 וכו'",
    dns1: "אנא הזן DNS1",
    dns2: "אנא הזן DNS2",
    sip1: "תצורת מידע sip1",
    config: "תצורת מידע",
    mode: "דֶגֶם",
    mode1: "מצב ישיר",
    mode2: "מצב שרת",
    user: "אנא הזן שם משתמש",
    userTitle: "שם משתמש",
    userTip: "ברירת המחדל היא להוסיף מספר לשם הקבוצה, כגון 1-1-1",
    last: "נא להזין את סיומת החשבון",
    sipTip: "אנא הזן את שם המשתמש והסיסמה הרשומים של שרת ה-SIP",
    password: "הזן את סיסמתך בבקשה",
    passwordTitle: "סיסמה",
    serverIp: "אנא הזן IP server",
    protocolType: "אנא בחר את סוג הפרוטוקול",
    protocolTypeTitle: "סוג הסכם",
    sip2: "תצורת מידע sip2",
    more: "יותר",
    close: "סגירת מעגל",
    formatError: "שגיאת עיצוב, נא להזין מחדש",
    forbidTip: "אסור להזין 127.0.0.1, נא להזין מחדש",
    call: "התקשר והתקשר",
    monitor: "צג",
    lift: "בקרת מעלית",
    rtsp: "זרם וידאו rtsp",
    deviceTip: "פונקציית התמיכה במכשיר לא יכולה להיות ריקה, אנא בחר שוב",
    maskTip1: "מסיכת רשת המשנה לא יכולה להיות ריקה, נא להזין מחדש",
    maskTip2: "הפורמט של מסכת רשת המשנה שגוי, נא להזין מחדש",
    gatewayTip1: "שער לא יכול להיות ריק, אנא היכנס מחדש",
    gatewayTip2: "שגיאה בפורמט שער, נא להזין מחדש",
    ipTip1: "כתובת ה-IP לא יכולה להיות ריקה, נא להזין מחדש",
    ipTip2:
      "שגיאה בפורמט כתובת IP, הגבול העליון הוא 255.254.254.253, הפסקה הראשונה אינה 0, נא להזין מחדש",
    dns1Tip1: "DNS1 לא יכול להיות ריק, אנא הכנס מחדש",
    dns1Tip2: "שגיאת פורמט DNS1, נא להזין מחדש",
    dns2Tip1: "שגיאת פורמט DNS2, נא להזין מחדש",
    passwordTip1: "הסיסמה לא יכולה להיות ריקה, נא להזין מחדש",
    serviceTip1: "serviceIp לא יכול להיות ריק, אנא הכנס מחדש",
    serviceTip2: "שגיאה בפורמט serviceIp, נא להזין מחדש",
    sip2Tip: "קבעת כעת מידע של sip2, אנא השלם אותו בהתאם לכללים",
    devnameTip1: "שם המכשיר לא יכול להיות ריק, נא להזין מחדש",
    devnameTip2: "שגיאה בפורמט שם מכשיר, נא להזין מחדש",
    nameTip1: "שם המשתמש לא יכול להיות ריק, אנא בחר שוב",
    nameTip2: "שם המשתמש לא יכול להיות ריק, אנא בחר שוב",
    maxTip1:
      "מספר המכשירים באזור הנוכחי הגיע לגבול העליון של 8, ולא ניתן להוסיף עוד",
    area: "אֵזוֹר",
    editArea: "אזור ערוך",
    addArea: "הוסף אזור",
    batchArea: "אזור הוספת אצווה",
    deleteArea: "מחק אזור",
    areaName: "שם אזור",
    areaNo: "מספר אזור",
    importAddr: "ייבוא פנקס כתובות",
    next: "השלב הבא",
    areaTip1: "אנא בחר את האזור לעריכה תחילה",
    areaTip2: "אנא בחר את האזור שיימחק תחילה",
    areaTip3:
      "האזור הנוכחי שלך ריק, אינך יכול להוסיף מכשירים באצווה כרגע, אנא הוסף מידע על אזור תחילה",
    noArea: "אין עדיין תצורת אזור",
    error: "חריג נתונים",
    addDevice: "הוסף מכשיר",
    editDevice: "ערוך מכשיר",
    delDevice: "מחק מכשיר",
    batchDevice: "הוסף מכשירים באצווה",
    prev: "קודם",
    updateAddr: "עדכן את ספר הכתובות של המכשיר",
    saveAddr: "שמור פנקס כתובות",
    exportAddr: "יצוא ספר כתובות",
    deleteTip: "האם למחוק את המכשיר",
    deleteTip2: "נבחר כרגע כאזור, אנא חזור לתצורת האזור כדי למחוק",
    deleteTip3: "אנא בחר תחילה את המכשיר למחיקה",
    deviceTip1: "אנא בחר את המכשיר לעריכה תחילה",
    deviceTip2: "אנא בחר את האזור תחילה, ולאחר מכן הוסף את המכשיר",
    exportSuccess: "היצוא הצליח",
    xmlTip: "אנא העלה את קובץ ה-xml של פנקס הכתובות",
    xmlTip1: "אנא בחר את קובץ ה-XML להעלאה",
    xmlTip2:
      "פנקס הכתובות המיובא אינו תואם את רמת הקהילה הנוכחית, והייבוא נכשל",
    areaConfig: "תצורת אזור",
    deviceConfig: "תצורת מכשיר",
    exportConfig: "תצוגה מקדימה ייצוא",
    projectConfig: "תצורת פרויקט",
    prevArea: "שייך לאזור העליון",
    areaNoTip: "מספר ההתחלה גדול ממספר הסיום, נא למלא שוב",
    smallAreaTip: "כרגע רמת השטח הקטן ביותר, לא ניתן להוסיף אזורי משנה נוספים",
    areaNoTip1:
      "מספר ההתחלה של החלק הראשון גדול ממספר הסיום של החלק הראשון, נא למלא שוב",
    areaNoTip2: "מספר ההתחלה של הזנב גדול ממספר הקצה של הזנב, נא למלא שוב",
  },
  push: {
    list: "Push Record",
    productType: "מספר מוצר",
    softwareName: "שם התוכנה",
    versionNo: "גרסת מספר",
    time: "דחף זמן",
    invalidTime: "תאריך תפוגה",
    upgrade: "שדרוג",
    upgradeRecord: "הצג רשומת שדרוג",
    deviceType: "סוג ציוד",
    deviceName: "שם התקן",
    currentSoftName: "שם תוכנת ההתקן הנוכחי",
    currentSoftNo: "מספר גרסה נוכחי של המכשיר",
    upgradeNo: "שדרג את מספר גרסת התוכנה",
    filterTip1: "נא להזין את שם המכשיר",
    filterTip2: "אנא בחר את שם התוכנה",
    filterTip3: "אנא בחר מספר גרסה",
    checkTip: "הפעל את טיק",
    ota: "שדרוג OTA",
    taskName: "שם המשימה",
    taskNameTip: "אנא הזן שם משימה",
    binName: "שם קושחה",
    upgradeType: "שיטת שדרוג משימות",
    done: "האם לבצע מיד",
    upgradeTime: "זמן שדרוג",
  },
  check: {
    submit: "מזל טוב, ההגשה הצליחה!",
    noSubmit: "אופס, ההגשה נכשלה!",
    file: "בחר מסמך",
    noFile: "אף קובץ לא נבחר",
    projectName: "שם הפרוייקט",
    projectNameTip: "אנא הזן שם פרויקט",
    describe: "לְתַאֵר",
    contentTip: "נא להזין תוכן",
    areaType: "היררכיה אזורית",
    example: "לדוגמה: בניין-יחידה-מספר חדר",
    areaTip: "פורמט מספר האזור שגוי, נא להזין מחדש",
    areaNameTip: "אנא הזן שם שכבה",
    nameTip: "השם לא יכול להיות ריק, נא להזין מחדש",
    nameError: "השם הוזן בצורה שגויה, נא להזין מחדש",
    nameLength: "אורך קלט השם הוא 4~50, נא להזין מחדש",
    areaNullTip: "רמת השטח לא יכולה להיות ריקה",
    formateError: "האורך הוא 1-6 ספרות, לא ניתן להזין סמלים מיוחדים",
    noAreaTip: "רמת השטח לא יכולה להיות ריקה, אנא בחר שוב",
    maxFileTip: "גודל הקובץ חורג מהמגבלה",
    xmlTip: "אנא העלה קובץ בפורמט XML",
  },
  book: {
    areaBy: "אזור",
    list: "רשימת כפילויות מידע על המכשיר",
    repeatTip:
      "מידע הציוד הבא משוכפל. אנא שנה את מידע הציוד המשוכפל. לאחר לחיצה על  אישור , הוא ישפוט את שכפול מידע קלט הציוד.",
    coverTip: "פעולה זו תחליף את נתוני הוספת האצווה של הרמה הנבחרת כעת",
    batchTip: "טווח ה-IP שנוצר על ידי הוספת מכשירים באצווה",
  },
  updateNewSip: {
    otaDeleteTip: "המחיקה נכשלה, ניתן למחוק רק משימות שלא התחילו",
    deleteArea1: "האם למחוק את האזור",
    deleteArea2: "במקביל, כל האזורים והמכשירים מתחת לאזור זה יימחקו יחד",
    codeRepeatTip:
      "לא ניתן לחזור על מזהה האזור באותה רמה, נא להזין מחדש את מזהה האזור הנוכחי",
    nameRepeatTip:
      "לא ניתן לשכפל שמות אזורים באותה רמה, נא להזין מחדש את שם האזור הנוכחי",
    deviceIp: "IP מכשיר",
    callin: "התקשר",
    callout: "לִנְשׁוֹף",
    systemMsg: "מידע מערכת",
    batchIpTip: "טווח ה-IP שנוצר על ידי הוספת מכשירים באצווה הפעם",
    ip: "כתובת ה - IP",
    mask: "מסכת רשת משנה",
    gateway: "כְּנִיסָה",
    noData: "לא",
    noAddressTip: "אין כרגע נתוני פנקס כתובות שניתן לסנכרן",
    operator: "מַפעִיל",
    goTip: "לחץ כדי לדלג לשלב המתאים",
    deviceNameTip: "אורך הקלט הוא 1-16 ספרות, לא ניתן להזין סמלים מיוחדים",
    filter1: "הזן שם אזור לסינון",
    filter2: "הזן שם אזור או שם מכשיר לסינון",
    secret: "סיסמת הצפנה",
    secretTip: "נא להזין סיסמה תוך 32 תווים, הפורמט אינו מוגבל",
    noSecretTip: "אפשר להתעלם מסיסמת הצפנה שלא הוגדרה",
    setSecret: "הגדר את סיסמת ההצפנה של ספר הכתובות",
    ignore: "הַזנָחָה",
    emptyBookTip: "פנקס הכתובות ריק ולא ניתן לייצאו באופן זמני",
    errorSecret: "שגיאת סיסמת הצפנת ספר כתובות, נא להזין מחדש",
    other: "אַחֵר",
    doorAuth: "בקרת גישה",
    funTitle: "אנא בדוק את הפונקציות הנתמכות על ידי המכשיר שהוספת",
    callInTip: "שיחת תמיכת מכשירים",
    callOutTip: "נקראת תמיכת מכשיר",
    monitorTip: "המכשיר תומך במעקב",
    doorTip: "המכשיר תומך בפונקציית ביטול נעילה",
    liftTip: "מעלית בקרת תמיכה במכשיר",
    maskTip: "אנא הזן את מסיכת רשת המשנה, הפניה לפורמט: 255.255.255.255",
    gatewayTip: "נא להזין את השער, הפניה לפורמט: 1.1.1.1",
    ip1: "אנא הזן את כתובת ה-IP, הפניה לפורמט: 1.1.1.1",
    ipTip: "כתובת ה-IP הקלט צריכה להימנע מ-IP מיוחד, כגון 127.0.0.1 וכו'",
    dns1: "אנא הזן DNS1, הפניה לפורמט: 1.1.1.1",
    dns2: "אנא הזן DNS2, הפניה לפורמט: 1.1.1.1",
    serverIp: "אנא הזן serverIp, הפניה לפורמט: 1.1.1.1 או שם דומיין",
    successxml: "הקובץ מנותח בהצלחה",
    groupCall: "שיחה קבוצתית",
    groupCallTip:
      "לאחר הפעלתו, תוכל להתקשר לכל המכשירים בקבוצה על ידי לחיצה על סמל השיחה הקבוצתית",
    record: "רשומה של גרסה",
    export: "יְצוּא",
    sync: "לְסַנכְרֵן",
    communityTip: "כרגע יש נתוני מכשיר שטח, החלפת רמת אזור אסורה",
    areaNameTitle: "תיאור היררכיה",
    noDataTip: "אין כרגע נתונים",
    areaCodeDescriptionTip:
      "התיאור האזור לא יכול להיות ריק, בבקשה מלא אותו לחלוטין",
    moduleName: "כלי הגדרת ספר הכתובות",
    userSipAccount: "קבוע למספר האזורי+מספר סידורי של המכשיר של הקבוצה המעולה",
    devMax: "מחשב המכשיר עובר את הגבול של 10000, הוספת נכשלה",
    areaMax: "העמוד האזורי עובר את הגבול של 10000, הוספת נכשלה",
    ipAndMaskTip1:
      "כתובת ה-IP מקושרת למסכת התת-רשת ויש לעבור על תקינות הלוגיקה העסקית של תוצאות עם כל 1 או כל 0 לאחר פעולת AND ביטית.",
    ipAndMaskTip2:
      "אם יש שגיאה בכלל בדיקת הלוגיקה העסקית, יש לשנות את כתובת ה-IP המתאימה.",
    ipAndMaskTip3:
      "כללי בדיקת הלוגיקה העסקית של מסכת התת-רשת וכתובת ה-IP אינם נכונים. יש לשנות את כתובת ה-IP.",
    ipAndMaskTip4:
      "בעת הוספת מכשירים בצורה המונית, יש לדלג באופן אוטומטי על כתובות ה-IP שאינן עומדות בבדיקת הלוגיקה העסקית.",
    correctMaskTip: "יש למלא תחילה את מסכת התת-רשת הנכונה.",
    correctIpTip: "יש להזין את כתובת ה-IP הנכונה.",
  },
  newDeviceType: {
    indoorMachine: "מכונה פנימית",
    doorPhone: "מתקשרת דלת",
    smallDoor: "מתקשרת דלת קטנה",
    manage: "מכשיר ניהול",
    wall: "מכשיר קיר",
    monitor: "מצלמת IP",
    unitGuard: "מכשיר ניהול יחידה",
    networkCard: "קורא כרטיסים לרשת",
    unitCard: "קורא כרטיסים ליחידה",
    lift: "מודול קישור למעלית",
    deviceTypeTip: "בבקשה, בחר את סוג המכשיר"
    }
};
